export default function track(category, action, label, value) {
  if ('ga' in window) {
    window.ga('send', 'event', category, action, label, value);
  }
}



/** WEBPACK FOOTER **
 ** ./src/lib/track.js
 **/